import { CreateStopTaskDto } from "@/core/features/tasks/embed-dtos/create-stop-task.dto";

export class UpdateStopTaskDto extends CreateStopTaskDto {}
